<template>
	<el-dialog title="发送位置" :visible.sync="visible" width="720px" :close-on-click-modal="false" @opened="onOpened" @closed="onClosed">
		<div class="location-picker">
			<div class="location-search">
				<el-input v-model="keyword" placeholder="搜索地址或地点名称" clearable @keyup.enter.native="onSearch">
					<i slot="suffix" class="el-input__icon el-icon-search" @click="onSearch"></i>
				</el-input>
			</div>
			<div ref="mapContainer" class="location-map"></div>
			<div class="location-footer">
				<div class="location-address">
					<div class="location-name">{{ current.address || '请选择位置' }}</div>
					<div class="location-detail" v-if="current.detailedAddress">{{ current.detailedAddress }}</div>
				</div>
				<div class="location-actions">
					<el-button @click="visible = false">取消</el-button>
					<el-button type="primary" :disabled="!current.longitude" @click="onConfirm">确定</el-button>
				</div>
			</div>
		</div>
	</el-dialog>
</template>

<script>
import { loadAMap } from "../../utils/amap.js";

export default {
	name: "LocationPicker",
	data() {
		return {
			visible: false,
			keyword: "",
			map: null,
			marker: null,
			placeSearch: null,
			geocoder: null,
			initialized: false,
			poiName: "",
			poiAddress: "",
			current: {}
		}
	},
	methods: {
		// 打开选择器（由父组件调用）
		async open() {
			if (!this.initialized) {
				// 首次打开前先加载高德脚本，失败则提示并关闭
				try {
					await loadAMap();
				} catch (e) {
					this.$message.error("地图加载失败，请检查网络或联系管理员");
					return;
				}
			}
			this.visible = true;
		},
		// dialog 打开动画结束：首次初始化地图，再次打开时刷新尺寸
		onOpened() {
			if (!this.initialized) {
				this.initMap();
			} else if (this.map) {
				this.map.resize();
			}
		},
		initMap() {
			this.initialized = true;
			const AMap = window.AMap;
			try {
				// 默认中心：北京
				this.map = new AMap.Map(this.$refs.mapContainer, {
					zoom: 15,
					center: [116.397428, 39.90923]
				});
				this.marker = new AMap.Marker({ map: this.map });
				this.placeSearch = new AMap.PlaceSearch({ pageSize: 10 });
				this.geocoder = new AMap.Geocoder({});
				// 点击地图选点
				this.map.on('click', (e) => {
					this.poiName = "";
					this.poiAddress = "";
					this.updateMarker(e.lnglat);
					this.reverseGeocode(e.lnglat);
				});
			} catch (e) {
				// key 无效 / 安全密钥错误 / 域名白名单未配置等会在此抛出
				this.initialized = false;
				this.visible = false;
				this.$message.error("地图初始化失败，请检查高德地图配置（key/安全密钥/域名白名单）或联系管理员");
			}
		},
		onSearch() {
			let keyword = this.keyword.trim();
			if (!keyword || !this.placeSearch) {
				return;
			}
			this.placeSearch.search(keyword, (status, result) => {
				if (status === 'complete' && result.poiList && result.poiList.pois.length) {
					let poi = result.poiList.pois[0];
					this.poiName = poi.name || "";
					this.poiAddress = poi.address || "";
					let lnglat = [poi.location.lng, poi.location.lat];
					this.map.setCenter(lnglat);
					this.map.setZoom(16);
					this.updateMarker(lnglat);
					this.reverseGeocode(lnglat);
					return;
				}
				// 区分"无结果"与"搜索服务异常"，避免误导用户
				if (status === 'no_data') {
					this.$message.warning("未找到相关地点，请尝试其他关键词");
				} else {
					this.$message.error("搜索服务异常，请稍后重试");
				}
			});
		},
		updateMarker(lnglat) {
			this.marker.setPosition(lnglat);
		},
		reverseGeocode(lnglat) {
			this.geocoder.getAddress(lnglat, (status, result) => {
				let formatted = (status === 'complete' && result.regeocode) ? (result.regeocode.formattedAddress || "") : "";
				this.current = {
					longitude: lnglat.lng,
					latitude: lnglat.lat,
					address: this.poiName || formatted || "当前位置",
					detailedAddress: this.poiName ? (formatted ? `${formatted} ${this.poiAddress}` : this.poiAddress) : formatted
				};
			});
		},
		onConfirm() {
			if (!this.current.longitude) {
				return;
			}
			this.$emit('confirm', Object.assign({}, this.current));
			this.visible = false;
		},
		onClosed() {
			this.current = {};
			this.poiName = "";
			this.poiAddress = "";
			this.keyword = "";
		}
	}
}
</script>

<style lang="scss" scoped>
.location-picker {
	.location-search {
		margin-bottom: 10px;
	}

	.location-map {
		width: 100%;
		height: 420px;
		border-radius: 4px;
	}

	.location-footer {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-top: 12px;

		.location-address {
			flex: 1;
			min-width: 0;
			margin-right: 16px;

			.location-name {
				font-size: 14px;
				font-weight: bold;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}

			.location-detail {
				font-size: 12px;
				color: #999;
				margin-top: 4px;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}
		}
	}
}
</style>
